import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="url(#paint0_linear_11378_10462)"/>
    <rect width="32" height="32" rx="16" fill="url(#paint1_linear_11378_10462)"/>
    <path d="M22.4001 23.2C22.4001 14.6667 9.6001 14.6667 9.6001 23.2M20.0001 12.8C20.0001 15.0092 18.2092 16.8 16.0001 16.8C13.791 16.8 12.0001 15.0092 12.0001 12.8C12.0001 10.5909 13.791 8.80005 16.0001 8.80005C18.2092 8.80005 20.0001 10.5909 20.0001 12.8Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
    <linearGradient id="paint0_linear_11378_10462" x1="-2.58521" y1="4.92613" x2="7.26704" y2="22.392" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FFFBC1"/>
    <stop offset="1" stop-color="#FD8D4B"/>
    </linearGradient>
    <linearGradient id="paint1_linear_11378_10462" x1="1.30574" y1="5.60463" x2="8.903" y2="19.7986" gradientUnits="userSpaceOnUse">
    <stop stop-color="#C1EAFF"/>
    <stop offset="1" stop-color="#3AA1FB"/>
    </linearGradient>
    </defs>
    </svg>
  );
};


export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

